import React, { useState } from "react";
import {
  Popper,
  TextField,
  Button,
  Box,
  ClickAwayListener,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import axios from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import CustomizedSnackbars from "./CommomsnackBar";

// Extend Day.js
dayjs.extend(utc);
dayjs.extend(timezone);
const TaskModelComponent = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [summary, setSummary] = useState("");
    const [description, setDescription] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const[snackBarData,setSnackBarData]=useState({message:"",severity:"error"});
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setSummary("");
    setDescription("");
    setSelectedDate(null);
    setStartTime(null);
    setEndTime(null);
  };

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };
  const handleStartTimeChange = (newTime) => {
    setStartTime(newTime);
  };
  const handleEndTimeChange = (newTime) => {
    setEndTime(newTime);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;
  const handleClickAway = () => {
    //setAnchorEl(null);
  };
  function combineDateTimeWithTimeZone(date, time) {
    const timeZone = dayjs.tz.guess()
    if (!date || !time) {
      console.error("Both date and time are required.");
      return null;
    }
  
    const combined = dayjs(date)
      .set("hour", dayjs(time).hour())
      .set("minute", dayjs(time).minute())
      .set("second", dayjs(time).second());
  
    const formatted = combined.tz(timeZone).format("YYYY-MM-DDTHH:mm:ssZ");
    return formatted;
  }
  const handleSave=()=>{
    //make an api call to send the data to the server
    console.log(selectedDate);
    let date=selectedDate.format("YYYY-MM-DD");//selectedDate.toISOString().split("T")[0];
    ;
    axios
    .post("https://calenderbackend-seven.vercel.app/calendar/events", { 
        email:props.email,
        summary,
        description,
        start:combineDateTimeWithTimeZone(date,startTime),
        end: combineDateTimeWithTimeZone(date,endTime),
        timeZone:dayjs.tz.guess(),
     })
    .then((response) => {
       // console.log(response.data);
        props.setEvents((prevEvents)=>[...prevEvents,response.data]);
        setSnackBarData({message:"Event added successfully",severity:"success"});
        handleClick();
    })
    .catch((err) => {
     
      console.error(err);
        setSnackBarData({message:"Failed to add event",severity:"error"});
     
    });

  }
  
  return (
    <div>
      <Button variant="contained" endIcon={<AddIcon />} onClick={handleClick}>
        Add Event
      </Button>
      <ClickAwayListener onClickAway={handleClickAway}>
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          placement="bottom-start"
          sx={{ boxShadow: 3, borderRadius: 2, marginTop: "8px !important" }}
        >
          <Box sx={{ p: 1, bgcolor: "background.paper" }}>
          <TextField id="standard-basic" label="Event Title"  value={summary}variant="standard" fullWidth  onChange={(e)=>setSummary(e.target.value)}/>
            <Box sx={{ p: 1 }}>
            <div>Description</div>
            <TextField multiline maxRows={4} fullWidth value={description} onChange={(e)=>setDescription(e.target.value)}/>
            </Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ p: 1 }}>
                <div> Date</div>
                <DatePicker value={selectedDate} onChange={handleDateChange} />
              </Box>
              <Box sx={{ p: 1 }}>
                <div>From</div>
                <TimePicker onChange={handleStartTimeChange} />
              </Box>
              <Box sx={{ p: 1 }}>
                <div>To</div>
                <TimePicker onChange={handleEndTimeChange} />
              </Box>
            </LocalizationProvider>
          </Box>
          <Box
            sx={{
              p: 2,
              bgcolor: "background.paper",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button variant="outlined" color="secondary"
            onClick={handleClick}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={!summary||!startTime || !endTime || !selectedDate}
              onClick={handleSave}
            >
              Save
            </Button>
          </Box>
        </Popper>
      </ClickAwayListener>
      <CustomizedSnackbars message={snackBarData.message} severity={snackBarData.severity}/>
    </div>
  );
};

export default TaskModelComponent;
